import { render } from "./SubmissionWizardStart.vue?vue&type=template&id=1c6d4009"
import script from "./SubmissionWizardStart.vue?vue&type=script&lang=js"
export * from "./SubmissionWizardStart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__